import HeroImg from "../assets/HeroImg.svg";
import Light from "../assets/Light.svg";
import WhoWeAre from "../assets/WhoWeAre.png";
import WhoWeAreTwo from "../assets/WhoWeAreTwo.png";
import PartnerUs from "../assets/PartnerUs.png";
import Logo from "../assets/Logo.svg";
import Lineheader from "../assets/Lineheader.svg";
import Line from "../assets/line.svg";

// ?import Popup session
import Popup1 from "../assets/Popup__Assets/Join-community-popup.png";
import Popup2 from "../assets/Popup__Assets/Startup-clinic-popup.png";
import Popup3 from "../assets/Popup__Assets/Digital-monetization-popup.png";
import Stroke1 from "../assets/Popup__Assets/Community-stroke.svg";
import Stroke2 from "../assets/Popup__Assets/Monetization-stroke.svg";

//? Comp Trust importing Section
import Mintyn from "../assets/CompTrust__Assets/Mintyn.png";
import Tekedia from "../assets/CompTrust__Assets/Tekedia.png";
import Playbooq from "../assets/CompTrust__Assets/Playbooq.png";
import kidoSchool from "../assets/CompTrust__Assets/Kibo-school.png";
import julieth from "../assets/CompTrust__Assets/julieth-logo.png";
import nexford from "../assets/CompTrust__Assets/Nexford.png"

//? OurPrograms importing Section
import Card1 from "../assets/OurPrograms__Section/Card 1.png";
import Card2 from "../assets/OurPrograms__Section/Card 2.png";
import Card3 from "../assets/OurPrograms__Section/Card 3.png";
import Card4 from "../assets/OurPrograms__Section/Card 4.png";
import Card5 from "../assets/OurPrograms__Section/Card 5.png";
import Card6 from "../assets/OurPrograms__Section/Card 6.png";
import Card7 from "../assets/OurPrograms__Section/Card 7.png";

// ? importting assets for Impact Report
import Handshake from "../assets/ImpactReport__Assets/Handshake.svg";
import TrainingTalents from "../assets/ImpactReport__Assets/TrainingTalents.svg";
import Resources from "../assets/ImpactReport__Assets/Resources.svg";
import Community from "../assets/ImpactReport__Assets/Community.svg";
import Volunteers from "../assets/ImpactReport__Assets/Volunteers.svg";
import StartupProjects from "../assets/ImpactReport__Assets/StartupProjects.svg";
import PartnershipFig from "../assets/ImpactReport__Assets/PartnershipFig.png";

// ? importing the Our Interest resource asset
import Interests from "../assets/OurInterests__Assets/Interests.png";

// ? importing Resources Assets
import Book1 from "../assets/Resources__Assets/Book-1.png";
import Book2 from "../assets/Resources__Assets/Book-2.png";
import Book3 from "../assets/Resources__Assets/Book-3.png";
import Book4 from "../assets/Resources__Assets/Book-4.png";

// ? importing Testimonials__Assets
import Star from "../assets/Testimonials__Assets/Star.svg";
import Testator__1 from "../assets/Testimonials__Assets/Testimonial__img1.png";
import Testator__2 from "../assets/Testimonials__Assets/Testimonial__img2.png";
import Testator__3 from "../assets/Testimonials__Assets/Testimonial__img3.png";
import Testator__4 from "../assets/Testimonials__Assets/Testimonial__img4.png";

// ? importing Footer Assets
import FooterLogo from "../assets/Footer__Assets/IWB Logo Project 1.svg";
import BackToTop from "../assets/Footer__Assets/BackToTop.svg";

// ?import Newsletter Asset
import Newsletter from "../assets/NewsLetter__Assets/NewsLetter.png";

// import hiring compoanies
import Amazon from "../assets/HiringCompanies__Assets/Amazon.svg";
import Flutterwave from "../assets/HiringCompanies__Assets/Flutterwave.svg";
import Google from "../assets/HiringCompanies__Assets/Google.svg";
import Stripe from "../assets/HiringCompanies__Assets/Stripe.svg";
import Apple from "../assets/HiringCompanies__Assets/apple.svg";
import Meta from "../assets/HiringCompanies__Assets/meta.svg";
import Microsoft from "../assets/HiringCompanies__Assets/microsoft.svg";
import Paystack from "../assets/HiringCompanies__Assets/paystack.svg";
import Andela from "../assets/HiringCompanies__Assets/andela.svg";
import NNPC from "../assets/HiringCompanies__Assets/NNPC_Logo.png";


import Knimi from '../assets/Talents_Assets/Knimi.png';
import Benjamin from '../assets/Talents_Assets/Benjamin.png';
import Ethelberth from '../assets/Talents_Assets/Ethelberth.png';
import Gracefield from '../assets/Talents_Assets/Gracefield.png';
import Hope from '../assets/Talents_Assets/Hope.png';
import Onyinye from '../assets/Talents_Assets/Onyinye.png';
import Timi from '../assets/Talents_Assets/Timi.png';
import Victoria from '../assets/Talents_Assets/Victoria.png';

const assets = {

  Knimi,
  Benjamin,
  Ethelberth,
  Gracefield,
  Hope,
  Onyinye,
  Timi,
  Victoria,

  Amazon,
  Apple,
  Flutterwave,
  Google,
  Stripe,
  Meta,
  Microsoft,
  Paystack,
  Andela,
  NNPC,

  Popup1,
  Popup2,
  Popup3,
  Stroke1,
  Stroke2,

  HeroImg,
  Logo,
  Lineheader,
  Line,
  Light,

  Mintyn,
  Tekedia,
  Playbooq,
  kidoSchool,
  julieth,
  nexford,

  WhoWeAre,
  WhoWeAreTwo,
  PartnerUs,

  Handshake,
  TrainingTalents,
  Resources,
  Community,
  Volunteers,
  StartupProjects,
  PartnershipFig,

  Card1,
  Card2,
  Card3,
  Card4,
  Card5,
  Card6,
  Card7,

  Interests,

  Book1,
  Book2,
  Book3,
  Book4,

  Star,
  Testator__1,
  Testator__2,
  Testator__3,
  Testator__4,
  FooterLogo,
  BackToTop,

  Newsletter,
};

export default assets;
